<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";

  export let show: boolean = false;
  export let distributor: string;
  export let volume: number;

  const onCloseModal = () => {
    show = false;
  };

</script>

<Modal bind:show closeOnBackgroundClick={true} fizzModal={true} size={"small"}>
  <div class="fizz-inset-square-24" data-testid="tabc-modal">
    <header class="fizz-stack-24 fizz-space-between">
      <h4 class="fizz-heading-4">Under minimum</h4>
      <div on:click={onCloseModal} data-testid="close-tabc-modal">
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
      </div>
    </header>
    <section class="fizz-text-medium">
      <p class="fizz-stack-24 fizz-text-strong">
        Your delivery order for {distributor} is under the TABC 2.4 gal minimum for spirits.
      </p>
      <p class="fizz-stack-24">To submit your order, you can do any of the following:</p>
      <ul class="fizz-unordered-list">
        <li>Add {volume} gal of spirits to your cart</li>
        <li>Select in-store pickup for spirits from {distributor}</li>
        <li>Remove spirits from your cart for {distributor} delivery</li>
      </ul>
    </section>
  </div>
</Modal>
